import { render, staticRenderFns } from "./ReasonsToSelect.vue?vue&type=template&id=2ac002e1&scoped=true&"
import script from "./ReasonsToSelect.vue?vue&type=script&setup=true&lang=js&"
export * from "./ReasonsToSelect.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ReasonsToSelect.vue?vue&type=style&index=0&id=2ac002e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac002e1",
  null
  
)

export default component.exports